"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyPlacesListDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const MyPlace_dto_1 = require("./MyPlace.dto");
class MyPlacesListDto {}
exports.MyPlacesListDto = MyPlacesListDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], MyPlacesListDto.prototype, "notificationsEnabled", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], MyPlacesListDto.prototype, "pinnedLimit", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => [MyPlace_dto_1.MyPlaceDto]
}), __metadata("design:type", Array)], MyPlacesListDto.prototype, "pinned", void 0);
//# sourceMappingURL=MyPlacesList.dto.js.map